var map = {
	"./components/uploads/config/uploads.settings.js": "./src/components/uploads/config/uploads.settings.js",
	"./config/app.settings.js": "./src/config/app.settings.js",
	"./config/files.settings.js": "./src/config/files.settings.js",
	"./config/icons.settings.js": "./src/config/icons.settings.js",
	"./config/prototype.settings.js": "./src/config/prototype.settings.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src sync recursive \\.settings\\.js$";